import styled, { css } from 'styled-components';
import { media } from '../../layouts/utils';

const colorBrandPrimary = {
  turquoise: `#28c4d6`,
  marine: `#24206b`,
  darkMarine: `#100B53`,
};

const colorNeutral = {
  light: `#ffffff`,
};

const fontFamily = {
  brand: `Galano Grotesque Alt`,
  neutral: `Open Sans`,
};

const fontSize = {
  xxl: `3rem`,
  xl: `2.5rem`,
  lg: `2rem`,
  md: `1.5rem`,
  xxxs: `0.75rem`,
  sm: `1.25rem`,
  xs: `1rem`,
  xxs: `0.875rem`,
};

export const ExternalLink = styled.a`
  color: ${(props) =>
    props.dark ? colorBrandPrimary.marine : colorNeutral.light};
  font-family: ${fontFamily.brand};
  font-size: ${(props) => (props.small ? fontSize.xxs : fontSize.xs)};
  height: ${(props) => props.img && '24px'};
  cursor: pointer;
  text-align: ${(props) => (props.center ? 'center' : 'start')};
  text-decoration: none;
  /* width: ${(props) => props.img && '24px'}; */

  ${(props) =>
    props.botaoEmbaixo &&
    css`
      align-self: center;
      ${media.desktop`
              padding-top: 24px;
          `}
    `}
`;
